import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import successIcon from 'assets/img/icons/success-green-big.svg'
import iconFail from "assets/img/icons/icon-warning.svg";
import { CraftIdentityContext } from "pages/CraftIdentity";
import PagePopopCloseButton from 'components/page-components/PagePopopCloseButton';
import { useSelector } from 'react-redux';
import CraftingIdentityPopupSelect from './CraftingIdentityPopupSelect';
import { useSoundPath } from 'hooks/useSoundPath';
import ModalWindow from 'components/ModalWindow';

const CraftingIdentityPopup = ({ setIsCraft, submitHandler, craftingStep, setCraftingStep, isCraftLoading, errorText }) => {

  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [activeName, setActiveName] = useState('Select')
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isCloseDisabled, setIsCloseDisabled] = useState(false);
  const {rarity} = useSelector((state) => state.crafting);
  const playSound = useSoundPath();

  const { clearBlocks } = useContext(CraftIdentityContext);

  const closeWindow = () => {
    playSound('main');
    if (craftingStep === 'success') {
      clearBlocks();
      setCraftingStep('submit')
    }
    setIsCraft(false);
    setCraftingStep('submit')
  }

  useEffect(() => {
    if (activeName !== 'Select' && isTermsAccepted === true) setIsSubmitDisabled(false);
    else {setIsSubmitDisabled(true);}
  }, [activeName, isTermsAccepted]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const element = document.querySelector('.uf-visible');
      setIsCloseDisabled(!!element);
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return (
    <ModalWindow close={closeWindow}>
      <div className={`modal-window__wrapper ${craftingStep === 'success' ? 'modal-window__wrapper--success' : ''}`} onClick={(e) => e.stopPropagation()}>
        <PagePopopCloseButton close={closeWindow} isDisabled={isCloseDisabled} />
        {
          craftingStep === 'submit' ? <section className="crafting-popup">
            <h2 className="modal-window__title">Assign a name to your Identity</h2>
            <form className="crafting-popup__form">
              <CraftingIdentityPopupSelect isVisible={isVisible} setIsVisible={setIsVisible} activeName={activeName} setActiveName={setActiveName} />
              <p className="crafting-popup__rarity">
                <span>Crafted Rarity:</span>
                <b>{rarity}</b>
              </p>
              <p className="crafting-popup__form-terms">
                <input type="checkbox" defaultChecked={isTermsAccepted} value="accept terms of crafting" id="crafting-terms" required />
                <label htmlFor="crafting-terms" onClick={() => setIsTermsAccepted(!isTermsAccepted)}>
                  I acknowledge these cards will be burned to create this identity and not returned to me.
                </label>
              </p>
              <footer className="modal-window__footer">
                <button
                  className="modal-window__footer-close"
                  disabled={isCloseDisabled}
                  onClick={() => {
                    setIsCraft(false);
                    playSound('main');
                  }}
                  >
                    Cancel
                  </button>
                <button className={`modal-window__footer-submit ${isCraftLoading ? 'loading' : ''}`}
                  disabled={isCraftLoading || isSubmitDisabled}
                  type='submit'
                  onClick={(e) => {
                    submitHandler(e)
                  }}>Craft Identity</button>
              </footer>
            </form>
          </section>
            : null
        }
        {
          craftingStep === 'success' ? <>
            <header className="modal-window__header">
              <img src={successIcon} className="modal-window__icon" alt="" />
              <h5 className="modal-window__title">Success!</h5>
            </header>
            <footer className="modal-window__footer">
              <button
                className="modal-window__footer-close"
                onClick={() => {
                  navigate('/inventory/identities/');
                  playSound('main');
                }}
              >
                View Identity
              </button>
              <button className="modal-window__footer-submit" onClick={closeWindow}>Craft another</button>
            </footer>
          </>
            : null
        }

        {
          craftingStep === 'fail' && (
            <>
            <header className="modal-window__header">
              <img src={iconFail} className="modal-window__icon" alt="" />
              <h5 className="modal-window__title">Craft prediction failed.</h5>
              <p className="modal-window__info">{errorText}</p>
            </header>
            <footer className="modal-window__footer">
              <button className="modal-window__footer-close" onClick={closeWindow}>Got it</button>
            </footer>
            </>
          )
        }
      </div>
    </ModalWindow>
  )
}

export default CraftingIdentityPopup;
